import { ContentStateInterface } from '../../../@types/types'
import { runValidation } from '../../../services/validation/editor/runValidation'
import { insertionChanged, insertionSave, validationSave } from '../../reducers/insertion/insertionFeature'
import { InitState } from '../../reducers/root/initialState'
import { AppDispatch } from '../../../@types/store'
import { ValidationResult } from '../../../@types/validation-types'

function validate(insertionData: ContentStateInterface, getState: () => InitState): ValidationResult {
  const { flowFeature, addressFeature } = getState()
  const { validationSchema } = flowFeature.flowInformation
  return runValidation(insertionData, addressFeature, validationSchema)
}

export const validateAndSaveInsertion =
  (newInsertionData: ContentStateInterface, asChanged?: boolean) =>
  (dispatch: AppDispatch, getState: () => InitState) => {
    const newValidationMessages = validate(newInsertionData, getState)

    dispatch(insertionSave({ insertionData: newInsertionData, validationResult: newValidationMessages }))
    if (asChanged) {
      dispatch(insertionChanged())
    }
  }
export const validateCurrentInsertion = () => (dispatch: AppDispatch, getState: () => InitState) => {
  const newValidationMessages = validate(getState().insertionFeature.insertionData, getState)

  dispatch(validationSave({ validationResult: newValidationMessages }))
}
